import { Timestamp } from '@firebase/firestore-types';
import { MedicalRecord } from './i-medical-record';
import { Sibling } from './i-sibling';

export interface IPatient {
    uid? : string;
    noRM? : number;
    idCard?: string;
    license?: string;
    otherCardName?: string;
    otherCardNumber?: string;
    fullName: string;
    nickName?: string;
    birthDate : Timestamp;
    birthPlace : string;
    // bloodType : string;
    sex : string;
    religion: string;
    maritalStatus : string;
    citizenship: string;
    education: string;
    otherEducation?:string;
    occupation: string;
    otherOccupation?: string;
    address: string;
    rt?: string;
    rw?: string;
    zipCode?: string;
    kelurahan?: string;
    kecamatan?: string;     
    kabupaten?: string;
    province? : string;
    homephoneNumber? : string;
    handphoneNumber : string;
    guarantor? : string;
    companyGuarantorName? : string;
    insurranceGuarantorName? : string;
    picName? : string;
    picRelationship? : string;
    picAddress? : string;
    picPhone? : string;
    spouseName? : string;
    fatherName? : string;
    fatherAge? : string;
    fatherEthnic? : string;
    fatherReligion? : string;
    fatherEducation? : string;
    fatherJob? : string;
    fatherInformation? : string;
    motherName? : string;
    motherAge? : string;
    motherEthnic? : string;
    motherReligion? : string;
    motherEducation? : string;
    motherJob?: string;
    motherInformation? :string;
    totalSibling : number;
    listSibling : Array<Sibling>;
    course1Name? : string;
    course1Duration? : string;
    course1Year? : string;
    course1Certificate?: string;
    course1Information?: string;
    course2Name? : string;
    course2Duration? : string;
    course2Year? : string;
    course2Certificate? : string;
    course2Information? : string;
    problem? : string;
    resolve? : string;
    effortResult? : string;
    isExamTaken? : string;
    examWhen? : string;
    examWhere? : string;
    examPurpose? : string;
    workplaceUID : string[];
    inputBy : string;
    inputDate : Timestamp;
    updateBy? : string;
    updateDate? : Timestamp;
    birthDateTmp? : Date;
    listMedicalRecord? : Array<MedicalRecord>
    noMedicalRecord? : string;
    eduSDName? : string;
    eduSDJurusan? : string;
    eduSDYearIn? : string;
    eduSDYearOut? : string;
    eduSDInfo? : string;
    eduSLTPName? : string;
    eduSLTPJurusan? : string;
    eduSLTPYearIn? : string;
    eduSLTPYearOut? : string;
    eduSLTPInfo? : string;
    eduSMUName? : string;
    eduSMUJurusan? : string;
    eduSMUYearIn? : string;
    eduSMUYearOut? : string;
    eduSMUInfo? : string;
    eduUnivName? : string;
    eduUnivJurusan? : string;
    eduUnivYearIn? : string;
    eduUnivYearOut? : string;
    eduUnivInfo? : string;
    job1HistoryName? : string;
    job1Title? : string;
    job1YearIn? : string;
    job1YearOut? : string;
    job1Info? : string;
    job2HistoryName? : string;
    job2Title? : string;
    job2YearIn? : string;
    job2YearOut? : string;
    job2Info? : string;
}

export class Patient implements IPatient{
    uid? : string;
    noRM?: number;
    idCard: string;
    license?: string;
    otherCardName?: string;
    otherCardNumber?: string;
    fullName: string;
    nickName?: string;
    birthDate: Timestamp;
    birthPlace: string;
    // bloodType: string;
    sex: string;
    religion: string;
    maritalStatus: string;
    citizenship: string;
    education: string;
    otherEducation? : string;
    occupation: string;
    otherOccupation?: string;
    address: string;
    rt?: string;
    rw?: string;
    zipCode?: string;
    kelurahan?: string;
    kecamatan?: string;
    kabupaten?: string;
    province?: string;
    homephoneNumber?: string;
    handphoneNumber: string;
    guarantor?: string;
    companyGuarantorName?: string;
    insurranceGuarantorName?: string;
    picName?: string;
    picRelationship?: string;
    picAddress?: string;
    picPhone?: string;
    spouseName?: string;
    fatherName?: string;
    fatherEthnic?: string;
    fatherReligion?: string;
    fatherEducation?: string;
    fatherJob?: string;
    fatherInformation?: string;
    fatherAge?: string;
    motherName?: string;
    motherAge?: string;
    motherEthnic?: string;
    motherReligion?: string;
    motherEducation?: string;
    motherJob?: string;
    motherInformation?: string;
    totalSibling: number;
    listSibling: Sibling[];
    course1Name?: string;
    course1Duration?: string;
    course1Year?: string;
    course1Certificate?: string;
    course1Information?: string;
    course2Name?: string;
    course2Duration?: string;
    course2Year?: string;
    course2Certificate?: string;
    course2Information?: string;
    problem?: string;
    resolve?: string;
    effortResult?: string;
    isExamTaken?: string;
    examWhen?: string;
    examWhere?: string;
    examPurpose?: string;
    workplaceUID : string[];
    inputBy : string;
    inputDate : Timestamp;
    birthDateTmp? : Date;
    updateBy : string;
    updateDate? : Timestamp;
    noMedicalRecord? : string;
    listMedicalRecord? : Array<MedicalRecord>;
    eduSDName? : string;
    eduSDJurusan? : string;
    eduSDYearIn? : string;
    eduSDYearOut? : string;
    eduSDInfo? : string;
    eduSLTPName? : string;
    eduSLTPJurusan? : string;
    eduSLTPYearIn? : string;
    eduSLTPYearOut? : string;
    eduSLTPInfo? : string;
    eduSMUName? : string;
    eduSMUJurusan? : string;
    eduSMUYearIn? : string;
    eduSMUYearOut? : string;
    eduSMUInfo? : string;
    eduUnivName? : string;
    eduUnivJurusan? : string;
    eduUnivYearIn? : string;
    eduUnivYearOut? : string;
    eduUnivInfo? : string;
    job1HistoryName? : string;
    job1Title? : string;
    job1YearIn? : string;
    job1YearOut? : string;
    job1Info? : string;
    job2HistoryName? : string;
    job2Title? : string;
    job2YearIn? : string;
    job2YearOut? : string;
    job2Info? : string;
    constructor(patient: Partial<Patient>){
        Object.assign(this, patient);
    }

}
